var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatisticsOtherPeriods = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#statistics_other_periods_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.334 1.333H2.667c-.733 0-1.333.6-1.333 1.333v10.667c0 .733.6 1.333 1.333 1.333h10.667c.733 0 1.333-.6 1.333-1.333V2.666c0-.733-.6-1.333-1.333-1.333m-8 12H2.667v-2.667h2.667zm0-4H2.667V6.666h2.667zm0-4H2.667V2.666h2.667zm4 8H6.667v-2.667h2.667zm0-4H6.667V6.666h2.667zm0-4H6.667V2.666h2.667zm4 8h-2.667v-2.667h2.667zm0-4h-2.667V6.666h2.667zm0-4h-2.667V2.666h2.667z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "statistics_other_periods_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgStatisticsOtherPeriods;